// import gsap from '/assets/js/lib/gsap/gsap.min.js'
// import ScrollTrigger from '/assets/js/lib/gsap/ScrollTrigger.min.js'
// import ScrollToPlugin from '/assets/js/lib/gsap/ScrollToPlugin.min.js'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassSwiperOffice {
  constructor(_target) {
    this.target = _target;
    this.mainSwiper;

    this.firstFlag = false;

    this.mainSwiperContainer = _target.querySelector(".office-slider__main .swiper-container");
    this.mainBtnNext = _target.querySelector(".office-slider__main .swiper-button-next");
    this.mainBtnPrev = _target.querySelector(".office-slider__main .swiper-button-prev");

    this.thumbSwiper;
    this.thumbSwiperContainer = _target.querySelector(".office-slider__thumb .swiper-container");

    // console.log("slideItemsW" + this.slideItemsW)
    // console.log("ALL" + this.targetSwiperWrapper.offsetWidth)
    this.excute();
  }

  excute() {
    const _this = this;

    _this.firstFlag = false;

    this.thumbSwiper = new Swiper(this.thumbSwiperContainer, {
        slidesPerView: 'auto',
        loop: false,
        watchSlidesProgress: true,  // thumbs連動でほぼ必須
        slideToClickedSlide: true,
        // PCだけ有効にしたいなら
        // breakpoints: {
        //   0: {
        //     centeredSlides: false,
        //     centeredSlidesBounds: false,
        //   },
        //   1024: {
        //     centeredSlides: true,
        //     centeredSlidesBounds: true,
        //   }
        // }

  // これが効く：左右に“逃げ”を作る
  // slidesOffsetBefore: 20,
  // slidesOffsetAfter: 16,
        // watchSlidesProgress: true,      // active判定に必要
        // slideToClickedSlide: true,
    });

    this.mainSwiper = new Swiper(this.mainSwiperContainer, {
      navigation: {
        nextEl: _this.mainBtnNext,
        prevEl: _this.mainBtnPrev,
      },
      speed: 700,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      thumbs: {
          swiper: _this.thumbSwiper,
      },
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 0, //15
      centeredSlides: false,
      on: {
        // 1. スライド切り替え開始時
        slideChangeTransitionStart: function () {
          _this.target.classList.add("is-slide");
        },
        // 2. スライド切り替え終了時
        slideChangeTransitionEnd: function () {
          _this.target.classList.remove("is-slide");
        },
      },
      loop: true,
      loopAdditionalSlides: 1,
      // loopedSlides: 8,
    });
    this.mainSwiper.autoplay.stop();
  }


}
